export const UPDATECURRENTFORUM = 'update_current_forum';

export const START_FETCHING_FORUMS = 'start_fetching_forums';
export const STOP_FETCHING_FORUMS = 'stop_fetching_forums';
export const FETCHING_FORUMS_SUCCESS = 'fetching_forums_success';
export const FETCHING_FORUMS_FAILURE = 'fetching_forums_failure';

export const START_FETCHING_USER = 'start_fetching_user';
export const FETCHING_USER_SUCCESS = 'fetching_user_success';
export const FETCHING_USER_FAILURE = 'fetching_user_failure';
export const SIGNOUT_USER_SUCCESS = 'signOut_user_success';
export const SIGNOUT_USER_FAILURE = 'signOut_user_failure';
